/* eslint-disable consistent-return, consistent-return, prefer-destructuring, no-mixed-operators, no-plusplus */

import React, { memo, useEffect, useState } from 'react'
import { ArcElement, Chart as ChartJS, Tooltip } from 'chart.js'
import { Pie } from 'react-chartjs-2'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { getGridColumns } from 'Modules/dashboard/dashboard'

ChartJS.register(ArcElement, Tooltip)

const ChartPieStyled = styled.div`
  display: inline-block;
  width: 30%;
`

const ChartPie = ({ initData }) => {
  const [parseData, setParseData] = useState(null)

  useEffect(() => {
    const gridColumns = initData ? getGridColumns(initData) : null
    if (initData && gridColumns && gridColumns.length > 0) {
      let years = []
      for (let i = 1; i < gridColumns.length; i++) {
        years.push({
          data: null,
          label: gridColumns[i].field
        })
      }

      years.push({
        data: null,
        label: 'Required'
      })

      const getRequiredArrayField = initData.map((item) => item.required)
      const getRaisedArrayField = initData.map((item) => item.raised)

      if (getRequiredArrayField.length === 0 || getRaisedArrayField.length === 0) {
        setParseData(years)
        return
      }

      const maxRequired = Math.max(...getRequiredArrayField)
      if (!Number.isFinite(maxRequired) || maxRequired === 0) {
        setParseData(years)
        return
      }

      let percents = Array(getRaisedArrayField.length).fill(0)
      percents[0] = Number((100 * getRaisedArrayField[0] / maxRequired).toFixed(2))

      let required = 0
      let total = percents[0]

      for (let i = 1; i < getRaisedArrayField.length; i++) {
        let num = Number((100 * Math.max(getRaisedArrayField[i] - getRaisedArrayField[i - 1], 0) / maxRequired).toFixed(2))
        if (total + num > 100) {
          num = 100 - total
        }
        total += num
        percents[i] = num
      }
      if (total < 100) {
        required = 100 - total
      }
      percents.push(Number(required.toFixed(2)))

      // eslint-disable-next-line no-unused-expressions
      years?.length > 0
        && percents?.forEach((item, index) => {
          // console.log(item)
          years[index].data = item
        })
      setParseData(years)
    } else {
      setParseData(null)
    }
  }, [initData])

  const options = {
    plugins: {
      tooltip: {
        callbacks: {
          label(context) {
            return `${context.label}: ${context.parsed}%`
          }
        }
      }
    }
  }

  const parsingDataForChart = (data) => (data && Array.isArray(data) ? data.filter((item) => item.data !== 0) : [])

  const chartData = parsingDataForChart(parseData)
  const dataChart = {
    labels: chartData.map((item) => item.label),
    datasets: [
      {
        data: chartData.map((item) => item.data),
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)',
          'rgba(142,128,115,0.2)'
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)',
          'rgba(142,128,115,0.2)'
        ]
      }
    ]
  }

  if (!chartData || chartData.length === 0) {
    return <ChartPieStyled />
  }

  return (
    <ChartPieStyled>
      <Pie data={dataChart} options={options} />
    </ChartPieStyled>
  )
}

ChartPie.propTypes = {
  initData: PropTypes.array
}

export default memo(ChartPie)
